// tslint:disable max-line-length
import React from 'react';

const Dashboard = () => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 3H3V13H11V3ZM9 4.99999V11H5V4.99999H9ZM21 3H13V9H21V3ZM19 4.99999V6.99999H15V4.99999H19ZM13 11H21V21H13V11ZM19 19V13H15V19H19ZM11 15H3V21H11V15ZM9 17V19H5V17H9Z"
    />
  </g>
);

export default Dashboard;
